import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  OnRentState,
  OnRentParams,
  OnRentApiResponse,
  OnRentHandleParams,
  OnRentHandleApiResponse,
  OnRentEndRentParams,
} from "./OnRentType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";
import { parseISO, format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

//情報取得API連携
export const fetchAsyncOnRent: any = createAsyncThunk<
  OnRentParams,
  OnRentApiResponse
>("OnRent/get", async () => {
  const response = await axiosSettings.get("api-admin/onRental");
  return response.data;
});

// handleLockの非同期アクション
export const fetchAsyncLock: any = createAsyncThunk<
  OnRentHandleApiResponse,
  OnRentHandleParams
>("onRentLock/post", async ({ rent_id }) => {
  const res = await axiosSettings.post("api-admin/lockMobility", {
    rent_id,
  });
  return res.data;
});

// handleUnlockの非同期アクション
export const fetchAsyncUnlock: any = createAsyncThunk<
  OnRentHandleApiResponse,
  OnRentHandleParams
>("onRentUnlock/post", async ({ rent_id }) => {
  const res = await axiosSettings.post("api-admin/unlockMobility", {
    rent_id,
  });
  return res.data;
});

// handleEndRentの非同期アクション
export const fetchAsyncEndRent: any = createAsyncThunk<
  OnRentHandleApiResponse,
  OnRentEndRentParams
>("onRentEndRent/post", async ({ rent_id, end_port_id, end_date }) => {
  const date = parseISO(end_date);
  const utcDate = toZonedTime(date, "UTC");
  const utcEndDate = format(utcDate, "yyyy-MM-dd'T'HH:mm:ss.SSSSSS");

  const res = await axiosSettings.post("api-admin/afterrental/end-rental", {
    rent_id,
    end_port_id,
    end_date: utcEndDate,
  });

  return res.data;
});

const initialState: OnRentState = {
  onRent: null,
  updatedTime: "",
  loading: false,
  error: "",
  handleRentMsg: "",
};

const OnRentSlice = createSlice({
  name: "OnRent",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //一覧表示用
    builder.addCase(fetchAsyncOnRent.fulfilled, (state, action) => {
      //トークン認証&通信成功、データを受け取る
      if (action.payload.status === "Success") {
        state.onRent = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
        state.loading = true;
      } else {
        state.error = action.payload.data;
      }
      state.loading = false;
    });
    //機体ロック用
    builder.addCase(fetchAsyncLock.fulfilled, (state, action) => {
      //レスポンスをstateに入れてアラート表示する
      const msg = action.payload.status;
      alert(msg);
    });
    //機体アンロック用
    builder.addCase(fetchAsyncUnlock.fulfilled, (state, action) => {
      //レスポンスをstateに入れてアラート表示する
      const msg = action.payload.status;
      alert(msg);
    });
    //レンタル終了処理用
    builder.addCase(fetchAsyncEndRent.fulfilled, (state, action) => {
      //レスポンスをstateに入れてアラート表示する
      const msg = action.payload.status;
      alert(msg);
    });
    builder.addCase(fetchAsyncEndRent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to end rent";
    });
  },
});

export const onRentInfo = (state: RootState) => state.OnRent.onRent;
export const onRentError = (state: RootState) => state.OnRent.error;
export const onRentLoading = (state: RootState) => state.OnRent.loading;
export const onRentUpdatedTime = (state: RootState) => state.OnRent.updatedTime;
export const onRentHandleMsg = (state: RootState) => state.OnRent.handleRentMsg;
export default OnRentSlice.reducer;
